import { Component, inject, OnInit } from '@angular/core';
import { BackendInterceptor } from '../../services/backend-interceptor/backend-interceptor.service';

@Component({
    selector: 'lib-assortment-management',
    templateUrl: './assortment-management.component.html',
    styleUrls: ['./assortment-management.component.css'],
    standalone: false
})
export class AssortmentManagementComponent{
  protected backendInterceptor = inject(BackendInterceptor) 

  backendBaseUrl = this.backendInterceptor.getBaseUrl();
}
